var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('jwczbtzc-block')],1)],1),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('zxzczc-block')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }